import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_API
axios.defaults.headers.common['Content-Type'] = 'application/json'
const token = localStorage.getItem('token')
axios.defaults.headers.common.Authorization = `Bearer ${token}`
axios.interceptors.request.use(config => {
  if (token) {
    if (typeof config.headers.common === 'undefined') {
      config.headers.common = {}
    }
    config.headers.common.Authorization = `Bearer ${token}`
  }
  if (config.url === '/login') {
    if (typeof config.headers?.common?.Authorization !== 'undefined') {
      delete config.headers.common.Authorization
    }
  }
  return config
})

axios.interceptors.response.use(
  response => response,
  async error => {
    if (error.response && error.response.status === 401 && error.response.data.error === 'Token no proporcionado') {
      // eslint-disable-next-line no-useless-catch
      try {
        const response = await axios.post('/refresh-token', {
          refresh_token: localStorage.getItem('refreshToken')
        })
        const newToken = response.data.token
        localStorage.setItem('token', newToken)
        error.config.headers.Authorization = `Bearer ${newToken}`
        return axios(error.config)
      } catch (refreshError) {
        throw refreshError
      }
    }
    throw error
  }
)

export default axios
